<template>
  <div>
    <span class="font-size-16 mr-2">
      {{ textoData }} {{ ultimaAtualizacao }}
    </span>
    <v-btn-toggle
      small
      rounded
    >
      <SGPFormBotaoComponent color="" @click.prevent="reload" small>
        <v-icon color="primary">mdi-reload</v-icon>
      </SGPFormBotaoComponent>
      <SGPFormBotaoComponent color="" @click="status = !status" small>
        {{ timeToString() }}
        <v-icon :color="!status ? 'blue' : 'primary'">mdi-{{ !status ? 'play' : 'pause' }}</v-icon>
      </SGPFormBotaoComponent>
    </v-btn-toggle>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: "SGPContadorRecarregamentoComponent",

  props: {
    formatoData: {
      type: String,
      required: false,
      default: 'DD/MM/YYYY HH:mm:ss'
    },

    textoData: {
      type: String,
      required: false,
      default: 'Última atualização'
    },

    totalSegundos: {
      type: Number,
      required: false,
      default: 60 * 5,
    },

    status: {
      type: Boolean,
      required: false,
      default: true
    },

    milissegundos: {
      type: Number,
      required: false,
      default: 1000,
    }

  },

  data () {
    return {
      toggle_exclusive: undefined,
      contador: 0,
      intervalId: 0,
      ultimaAtualizacao: moment(new Date()).format(this.formatoData),
    }
  },

  created () {
    this.contador = this.totalSegundos
    this.play()
  },

  computed: {
    contando () {
      return this.contador
    }
  },

  methods: {
    play () {
      if (!this.status) {
        if (this.intervalId === 0) return
        clearInterval(this.intervalId)
      } else {
        this.intervalId = setInterval(async () => {
          if (this.contador === 0) {
            await this.emissorEvento()
            this.ultimaAtualizacao = moment(new Date()).format(this.formatoData),
            this.contador = this.totalSegundos
          }
          this.contador = this.contador - 1
        }, this.milissegundos)
      }
    },

    reload () {
      this.status = true
      this.contador = 0
    },

    timeToString() {
      const minutes = Math.floor(this.contador / 60);
      const seconds = this.contador % 60
      return `${this.parseTimeString(minutes)}:${this.parseTimeString(seconds)}`
    },

    parseTimeString (val) {
      return `${val.toString().padStart(2, '0')}`
    },

    emissorEvento () {
      this.$emit('sgpContadorRecarregamentoAtualizar')
    }
  },

  watch: {
    status () {
      this.play()
    }
  }
}
</script>